__turbopack_context__.v({
  "questionDetailSection": "P-RtOa_questionDetailSection",
  "richTextContainer": "P-RtOa_richTextContainer",
  "supportLink": "P-RtOa_supportLink",
});
